import React from "react"

import Layout from "../components/layout"

const ContactPage = () => (
  <Layout activePath='contact' pageTitle="Contact Us"></Layout>
)

export default ContactPage
